<div class="tab-content">
  <div class="documents-section">
    <ng-container *ngFor="let group of documentGroups">
      <div class="group-header">
        <h6>{{ group.type }}</h6>
      </div>
      <div class="documents-list">
        <div class="doc-row" *ngFor="let doc of group.documents">
          <div class="doc-info" (click)="onOpenDocumentSheet(doc)">
            <span class="doc-title">{{ doc.title }}</span>
          </div>
          <div class="doc-actions">
            <span class="doc-file-icon" (click)="onDownloadDocument(doc)">
              <fa-icon [icon]="faFileLines"></fa-icon>
            </span>
            <button type="button" class="delete-btn" (click)="onDeleteDocument($event, doc)" [attr.aria-label]="'Delete' | translate">
              <i class="fa-regular fa-trash-can"></i>
            </button>
          </div>
        </div>
      </div>
    </ng-container>
  </div>

  <!-- FAB Button -->
  <button type="button" class="add-document-fab" (click)="onAttachNewDocument()" [title]="'Add a document' | translate">
    <i class="fa-thin fa-plus fa-2x"></i>
  </button>
</div>
